// extracted by mini-css-extract-plugin
export var highlightFade = "_2c-4";
export var highlighted = "_2c-3";
export var table = "_2c-1";
export var tableContainer = "_2c-0";
export var totalsRow = "_2c-2";